<template>
  <div id="app">
    <!--产品展示开始-->
    <div class="backdrop main-Product" id="main-ProductDisplay">
      <p class="caption headline">{{ $t('Project')}}</p>
      <!--<p class="caption">方案展示</p>-->
      <div class="product-display">
        <router-link  v-for="(obj,index) in $t('productDisplay')" :to="obj.href" :key="index">
          <div >
            <img :src="obj.img"/>
            <p>{{obj.name}}</p>
            <p>&nbsp; &nbsp; &nbsp; &nbsp;{{obj.introduce}}</p>
          </div>
        </router-link>
      </div>
      <p class="view-more "><router-link to="/productDisplay">{{$t('viewMore')}} >></router-link></p>
    </div>
    <!--产品展示结束-->
    <!--关于我们开始-->
    <div class="main-AboutUs backdrop" id="main-AboutUs">
      <p class="caption headline">{{$t('AboutUs')}}</p>
      <!--<p class="caption">公司简介</p>-->
      <div class="introduce">
        <div>
          <img src="../assets/img/title/style2.png"/>
          <img src="../assets/img/title/style3.png"/>
        </div>
        <div class="introduce-text">
          <p v-for="(obj,index) in $t('introduce')" :key="index">
								<span>
									&nbsp; &nbsp; &nbsp; &nbsp;{{obj}}
								</span>
          </p>
        </div>
      </div>
      <p class="view-more "><router-link to="/mainAboutUs">{{$t('viewMore')}} >></router-link></p>
    </div>
    <!--关于我们结束-->
    <!--新闻动态开始-->
    <!--<div class="backdrop main-News" id="main-News">-->
      <!--<p class="caption headline">NEWS</p>-->
      <!--<p class="caption">新闻动态</p>-->
      <!--<ul class="News-ul">-->
        <!--<li v-for="obj in $t('newsTrends')">-->
          <!--<div class="News-Data">-->
            <!--<p>{{obj.id}}</p>-->
            <!--<span>{{obj.date}}</span>-->
          <!--</div>-->
          <!--<div class="News-message">-->
            <!--<h4>{{obj.title}}</h4>-->
            <!--<span>{{obj.content}}</span>-->
          <!--</div>-->
        <!--</li>-->
      <!--</ul>-->
      <!--<p class="view-more "><router-link to="/News">查看更多 >></router-link></p>-->
    <!--</div>-->
    <!--新闻动态结束-->
  </div>
</template>

<script>
  export default {
    name: "home",
    data: function () {
      return {
      }
    }
  }
</script>

<style scoped>
  #app{
    display: flex;
  }
  #app>div{
    flex-grow: 1;
  }
  .product-display,
  .introduce{
    min-height: 7rem;
  }
  /*关于我们开始*/
  #main-ProductDisplay{
    width: 50%;
  }
  #main-AboutUs{
    width: 50%;
  }
  .main-AboutUs{
    /*background-image: url(../assets/img/pic/pic_ABOUT.jpg);*/
    background-repeat:no-repeat;
  }
  .main-AboutUs .introduce{
    display: flex;
    flex-wrap:wrap;
    margin: 0.3rem 0.3rem;
    padding: 0.3rem;
    box-shadow: 0 0 30px 0 #B0B0B0;
    border-radius: 10px;
    min-height: 870px;

    /*animation: 2s aircraft;*/
  }
  .main-AboutUs .introduce>div{
    width: 100%;
    flex-grow: 1;
    align-self:center;
  }
  .main-AboutUs .introduce>div span{
    font-size: 22px
  }
  .main-AboutUs .introduce>div:first-of-type{
    text-align: center;
  }
  .main-AboutUs .introduce img{
    width: 43%;
    margin:0 10px ;
    border: 1px solid #000;
  }
  .main-AboutUs .introduce span{
    font-family: 微软雅黑;
    font-size: 14px;
    line-height: 200%;
    color: #5a5a5a;
  }
  /*关于我们结束*/
  /*产品展示开始*/
  .main-Product{
    /*background-image: url(../assets/img/pic/pic_PRODUCT.jpg);*/
    /*background-repeat:no-repeat;*/
  }
  .product-display{
    margin: .3rem .3rem ;
    padding: .3rem;
    display: flex;
    flex-wrap: wrap;
    border-radius: 10px;
    box-shadow: 0 0 30px 0 #B0B0B0;
    min-height: 870px;

  }
  .product-display a{
    width: 2.1rem;
    text-align: center;
    flex-grow: 1;
    margin: .1rem;
    transition: all 0.5s;
    background-color: #fff;
    /*padding-bottom: 0.8rem;*/
    /*height: 4rem;*/
    padding-bottom:0.2rem ;
  }
  .product-display a:hover{
    cursor: pointer;
    transform: translate(0,-5px);
    box-shadow: 0 0 30px 0 #B0B0B0;
    cursor: pointer;
  }
  .product-display div img{
    width: 100%;
    height: 2rem;
  }


  /*产品展示结束*/
  /*新闻动态开始*/
  .main-News{
    background-image: url(../assets/img/pic/pic_NEWS.jpg);
    background-repeat:no-repeat;
    width: 100%;
  }
  .News-Data{
    width: 100px;
    height: 80px;
    background-color: #cc0000;
    color: #FFFFFF;
    text-align: center;
    padding:15px 5px;
  }
  .News-Data p{
    font-size: 30px;
  }
  .News-Data span{
    font-size: 16px;
  }
  .News-ul{
    margin: .3rem .7rem ;
  }
  .News-ul li{
    width: 100%;
    padding: 20px 0;
    border-bottom: 1px dotted #dbd4cd;
    overflow: hidden;
  }
  .News-ul li div{
    float: left;
  }
  .News-message{
    width: 85%;
    margin-left: 0.5rem;
  }

  .News-message span{
    font-size: 16px;
    line-height: 25px;
  }

  /*新闻动态结束*/
  @media screen and (max-width: 1024px) {
    /* 新闻动态 */
    .News-message{
      width: 80%;
      /* margin-left: 0.1rem; */
      font-size: 14px;
    }
    #app{
      flex-wrap: wrap;
    }
    #app>div{
      margin-bottom: 30px;
    }
    #main-ProductDisplay,#main-AboutUs{
      width: 100%;
    }
    .product-display,
    .main-AboutUs .introduce{
      box-shadow: none;
      padding: 0;
    }
    .product-display a{
      width: 5rem;
    }
    .product-display a:hover{
      cursor: pointer;
      transform: translate(0,0);
      box-shadow: 0 0 0 0 #B0B0B0;
    }
    .product-display div img{
      height: 4.5rem;
    }
    .product-display div p:nth-child(2){
      font-size: 16px;
    }
    .product-display div p:nth-child(3){
    font-size: 14px;
    display: -webkit-box;
    /*-webkit-line-clamp: 4;*/
    /*-webkit-box-orient: vertical;*/
    overflow: hidden;
    }
    .backdrop{
      padding: 10px 0;
    }
    .main-AboutUs .introduce img{
      width: 40%;
    }
    .main-AboutUs .introduce>div span{
      font-size: 16px;
    }
    .News-message h4{

    }
    .News-message span{
      font-size: 12px;
    }
  }

  /*@media screen and (max-width:768px){*/
    /*.main-AboutUs .introduce img{*/
      /*width: 60%;*/
    /*}*/
    /*!*关于公司*!*/
    /*.main-AboutUs .introduce>div span{*/
      /*font-size: 16px;*/
    /*}*/
    /*.main-AboutUs .introduce>div{*/
      /*display: -webkit-box;*/
      /*-webkit-line-clamp: 8;*/
      /*-webkit-box-orient: vertical;*/
      /*overflow: hidden;*/
    /*}*/
    /*!* 新闻动态 *!*/
    /*.News-message{*/
      /*width: 60%;*/
      /*!* margin-left: 0.1rem; *!*/
      /*font-size: 14px;*/
    /*}*/
    /*.News-message span{*/
      /*display: -webkit-box;*/
      /*-webkit-line-clamp: 3;*/
      /*-webkit-box-orient:*/
        /*vertical;overflow: hidden;*/
    /*}*/
    /*!* 产品展示 *!*/
    /*.product-display{*/
      /*flex-wrap:wrap;*/
    /*}*/
    /*.product-display a {*/
      /*width: 7rem;*/
    /*}*/
    /*.product-display a:hover{*/
      /*cursor: pointer;*/
      /*transform: translate(0,0);*/
      /*box-shadow: 0 0 0 0 #B0B0B0;*/
    /*}*/
    /*.product-display div img{*/
      /*height: 4rem;*/
    /*}*/
    /*.product-display div p:nth-child(2){*/
      /*font-size: 16px;*/
    /*}*/
    /*.product-display div p:nth-child(3){*/
      /*font-size: 14px;*/
      /*display: -webkit-box;*/
      /*-webkit-line-clamp: 4;*/
      /*-webkit-box-orient: vertical;*/
      /*overflow: hidden;*/
    /*}*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/components/home2.vue